module.exports = __webpack_public_path__ + "assets/img/user-full.3dc63ee2.svg";